<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-02 13:16:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-08-02 15:06:30
 -->
<template>
  <div class="deptMana">
    <div class="add-btn-box">
      <el-button type="primary" @click="add">新增</el-button>
    </div>
    <div
      class="alarm-table"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table :data="tableList" style="width: 100%">
        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="staffing" label="人员配置数量" align="center">
        </el-table-column>
        <el-table-column prop="mileage" label="服务里程" align="center">
        </el-table-column>
        <el-table-column prop="positionCN" label="位置信息" align="center">
        </el-table-column>
        <el-table-column prop="road" label="维护路段信息" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      :current-page="pagination.currentPage"
      layout="prev, pager, next"
      :total="pagination.total"
      @current-change="pageChange"
    ></el-pagination>
    <!-- 弹窗新增编辑 -->
    <base-dialog
      :title='dialogTitle'
      size="small"
      :visible.sync="dialogTableVisibles"
      v-if="dialogTableVisibles"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="dept-ruleForm"
      >
        <el-form-item
          label="名称"
          prop="name"
          label-width="120px"
          :rules="{
            required: true,
            message: '名称不能为空',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="人员配置数量"
          prop="staffing"
          label-width="120px"
          :rules="{
            required: true,
            message: '人员配置数量不能为空',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.staffing"></el-input>
        </el-form-item>
        <el-form-item
          label="服务里程"
          prop="mileage"
          label-width="120px"
          :rules="{
            required: true,
            message: '服务里程不能为空',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.mileage"></el-input>
        </el-form-item>
        <el-form-item
          label="维护路段信息"
          label-width="120px"
          prop="road"
          :rules="{
            required: true,
            message: '维护路段信息不能为空',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.road"></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="位置信息"
          prop="position"
          label-width="120px"
          :rules="{
            required: true,
            message: '位置信息不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.position" placeholder="请选择位置信息">
            <el-option
              v-for="item in areaList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          label="位置（省）"
          prop="provinceId"
          label-width="120px"
          :rules="{
            required: true,
            message: '省份信息不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.provinceId" @change="provinceChange" placeholder="请选择省份">
            <el-option
              v-for="item in provinceOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="位置（市）"
          prop="cityId"
          label-width="120px"
          :rules="{
            required: true,
            message: '市级信息不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.cityId" @change="cityChange" placeholder="请选择城市">
            <el-option
              v-for="item in cityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="handle">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/BaseDialog.vue'
import {
  getDeptlist,
  deptSave,
  getDeptDetailData,
  updateDept,
  deleteDept,
  getlistDictByType,
} from './service'
export default {
  name: 'deptMana',
  components: {
    BaseDialog,
  },
  data () {
    return {
      dialogTitle: '',
      dialogTableVisibles: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dialogState: 'add',
      loading: false,
      tableList: [],
      ruleForm: {
        name: '',
        staffing: '',
        mileage: '',
        road: '',
        // position: '',
        provinceId: '',
        cityId: '',
      },
      provinceOptions: [],
      cityOptions: [],
      deptList: [],
      id: '',
      areaList: [],
    }
  },
  methods: {
    // 省份选择change事件
    provinceChange (e) {
      this.ruleForm.provinceId = e
      this.$http.get('/rest/base/area/dropDownList', {
        pid: e,
      }).then(res => {
        if (res.code === 0) {
          this.cityOptions = res.data
        } else {
          this.$message({
            type: 'error',
            message: '市级数据获取失败',
          })
        }
      })
    },
    // 市级change事件
    cityChange (e) {
      this.ruleForm.cityId = e
    },
    // 获取省级区域下拉列表
    getProvinceData () {
      this.$http.get('/rest/base/area/dropDownList', {
        level: 1,
      }).then(res => {
        if (res.code === 0) {
          this.provinceOptions = res.data
        } else {
          this.$message({
            type: 'error',
            message: '省份数据获取失败',
          })
        }
      })
    },
    /**
     * @description:   获取列表
     * @return {*}
     */
    async getList () {
      const params = {
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      const res = await getDeptlist(params)
      if (res.code === 0) {
        let data = res.data.list
        data.map(item => {
          let position = this.areaList.find(k => {
            return k.code === item.position
          })
          if (position) {
            item.positionCN = position.name
          } else {
            item.positionCN = ''
          }
        })
        this.tableList = data
        this.pagination.total = Number(res.data.total)
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
        })
      }
    },
    // 获取位置列表
    async getlistDictType () {
      const params = {
        type: 2,
      }
      const res = await getlistDictByType(params)
      this.areaList = res.data
    },
    // 新建用户弹窗关闭
    resetForm (formName) {
      this.ruleForm.name = ''
      this.ruleForm.staffing = ''
      this.ruleForm.mileage = ''
      this.ruleForm.road = ''
      // this.ruleForm.position = ''
      this.ruleForm.provinceId = ''
      this.ruleForm.cityId = ''
      this.$refs.ruleForm.clearValidate()
      this.dialogTableVisibles = false
    },
    /**
     * @description:   分页改变事件
     * @param {Number} currPage  当前页码
     * @return {*}
     */
    pageChange (currPage) {
      this.pagination.currentPage = currPage
      this.getList()
    },
    // 新增事件
    add () {
      this.dialogState = 'add'
      this.dialogTableVisibles = true
      this.dialogTitle = '新增'
    },
    // 编辑
    handleEdit (index, row) {
      this.id = row.id
      this.getDeptDetail(row.id)
      this.dialogState = 'edit'
      this.dialogTitle = '编辑'
    },
    // 获取详情
    async getDeptDetail (id) {
      const res = await getDeptDetailData(id)
      this.dialogTableVisibles = true
      let data = res.data
      this.ruleForm = data
    },
    // 删除
    handleDelete (index, row) {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteDept(row.id)
          if (res.code === 0) {
            this.$message.success({ message: '操作成功', duration: 1500 })
            this.pagination.currentPage = 1
            this.getList()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 新建
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogState === 'add') {
            this.save()
          } else {
            this.update()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改
    async update () {
      const params = {
        name: this.ruleForm.name,
        staffing: this.ruleForm.staffing,
        mileage: this.ruleForm.mileage,
        road: this.ruleForm.road,
        // position: this.ruleForm.position,
        provinceId: this.ruleForm.provinceId,
        cityId: this.ruleForm.cityId,
        id: this.id,
      }
      const res = await updateDept(params)
      if (res.code === 0) {
        this.$message.success({ message: '修改成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getList()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
    // 保存新增
    async save () {
      const params = {
        name: this.ruleForm.name,
        staffing: this.ruleForm.staffing,
        mileage: this.ruleForm.mileage,
        road: this.ruleForm.road,
        // position: this.ruleForm.position,
        provinceId: this.ruleForm.provinceId,
        cityId: this.ruleForm.cityId,
      }
      const res = await deptSave(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getList()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
  },
  mounted () {
    this.getList()
  },
  created () {
    this.getlistDictType()
    this.getProvinceData()
  },
}
</script>

<style lang="less" scoped>
  .deptMana{
    position: relative;
    .alarm-table {
      margin-top: 60px;
    }
    .add-btn-box {
      position: absolute;
      right: 60px;
      top: -38px;
      z-index: 1;
    }
    .dept-ruleForm {
      margin: 15px 50px;
    }
  }
</style>
